import { render } from "./CustomGlobalHTML.vue?vue&type=template&id=3c2f425c"
import script from "./CustomGlobalHTML.vue?vue&type=script&lang=js"
export * from "./CustomGlobalHTML.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__